(() => {
  if (window.__tmpMobilePdpBuybarReady) return;
  window.__tmpMobilePdpBuybarReady = true;

  const mq = window.matchMedia('(max-width: 749px)');
  const CLASS = 'tmp-mobile-pdp-buybar';
  const ACTIVE_CLASS = 'tmp-mobile-pdp-buybar-active';
  let current = null;
  let marker = null;
  let scheduled = false;

  const isProductPage = () => document.body?.classList.contains('product-template');

  const findInlineCandidate = () => {
    const bundle = document.querySelector('#MainContent .tmp-meller-offer .tmp-meller-cta-wrap');
    if (bundle) return bundle;
    return document.querySelector('#MainContent .tmp-standard-native-atc') ||
      document.querySelector('#MainContent .product__block--buy_buttons');
  };

  const rememberOrigin = (node) => {
    if (!node?.parentNode || marker?.isConnected) return;
    marker = document.createComment('tmp-mobile-pdp-buybar-origin');
    node.parentNode.insertBefore(marker, node);
  };

  const restore = () => {
    if (!current) {
      document.body?.classList.remove(ACTIVE_CLASS);
      return;
    }

    if (marker?.parentNode) {
      marker.parentNode.insertBefore(current, marker.nextSibling);
      marker.remove();
    }

    current.classList.remove(CLASS);
    current.removeAttribute('data-tmp-mobile-buybar');
    current = null;
    marker = null;
    document.body?.classList.remove(ACTIVE_CLASS);
  };

  const sync = () => {
    scheduled = false;
    if (!isProductPage()) return restore();

    if (!mq.matches) {
      restore();
      return;
    }

    if (current && !current.isConnected) {
      current = null;
      marker = null;
    }

    const candidate = current || findInlineCandidate();
    if (!candidate) return;

    if (current && candidate !== current) restore();
    if (!current) current = candidate;

    rememberOrigin(current);
    current.classList.add(CLASS);
    current.setAttribute('data-tmp-mobile-buybar', 'true');

    if (current.parentNode !== document.body) document.body.appendChild(current);
    document.body.classList.add(ACTIVE_CLASS);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  if (mq.addEventListener) mq.addEventListener('change', schedule);
  else if (mq.addListener) mq.addListener(schedule);

  document.addEventListener('variant:changed', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:block:select', schedule);
  document.addEventListener('cart:refresh', schedule);

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
